import { environment as config } from '@coverright/shared/config';

export const environment = {
  ...config,
  aircallUrl: config.clientFileUploadUrl + '/api/air-call-recording',
  fileUploadUrl: config.clientFileUploadUrl + '/api/plan-file/',
};
